// extracted by mini-css-extract-plugin
export default {"GallerySection":"GallerySection_GallerySection__Y-5q7","title":"GallerySection_title__lEdTf","gallery-image":"GallerySection_gallery-image__qfgzf"};